// assets are ketch static assets like logos
export const assets = {
  root: {
    pattern: '/static-assets',
    getURL: () => '/static-assets',
  },
}
